import { Page } from '@/core/architecture'

import { Forbidden } from '../Errors/Forbidden'
import { LotteryDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * LotteryDetail Page
 * Implemented as a practical sample.
 */
export const LotteryDetail: Page = () => {
  const { state, actions } = useViewModel()

  if (state.isRootAuthFailed) {
    return <Forbidden useNextRouter={false} />
  }

  return <LotteryDetailTemplate state={state} {...actions} />
}
